import React from "react";
import style from "./index.module.css";
import Img from "../../components/Image";

function PerformanceMetrics() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  // Function to update window width
  const handleWindowResize = () => {
    setWindowWidth(window.innerWidth);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleWindowResize);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  return (
    <div className={style.performanceContainer}>
      <div className={style.performanceContentCont}>
        <div className={style.performanceTop}>
          <p>BORG Performance Metrics</p>
          <p>
            Deep-dive into the statistics of BORG and understand the mechanics
            of the SwissBorg ecosystem.
          </p>
        </div>
        <div className={style.performanceBottom}>
          {/* <Img
            src="/Images/performanceMetrics/banner.png"
            src="/Images/performanceMetrics/bannerMobile.png"
            className={style.performanceBottomImg}
          ></Img> */}
          {windowWidth < 600 ? (
            <Img
              src="https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2FPerformanceMetrics%2FbannerMobile.webp?alt=media&token=43289235-9bd0-47fd-a011-89648ab999e3"
              className={style.performanceBottomImg}
              alt="Mobile Banner"
            />
          ) : (
            <Img
              src="https://firebasestorage.googleapis.com/v0/b/nexusconnects-bfe18.appspot.com/o/aidtaasImages%2Fimages%2FPerformanceMetrics%2Fbanner.webp?alt=media&token=5e4302c8-f914-4b09-9405-49bebf0cbaaf"
              className={style.performanceBottomImg}
              alt="Desktop Banner"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default PerformanceMetrics;
